import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

export const OrderPacked = ({size}) => {
    return (
        <DotLottieReact
            src="https://lottie.host/e9bc71cc-8212-4efe-93d2-252036382a1f/Mr0ps0FJ0p.lottie"
            loop
            autoplay
            size={size}
        />
    );
};
